export const activityApi = {
  getActivityTypes: ({ appSecret }) => ({ url: 'v2/:clientId/activities/types', method: 'get', params: { appSecret } }),
  getActivityList: ({ appSecret, include = 'cl' }) => ({
    url: 'v2/:clientId/activities/list',
    method: 'get',
    params: { appSecret, include },
  }),
  getPromotionList: () => ({
    url: 'v2/:clientId/payment/v2/bank-wallet/promotions',
    method: 'get',
  }),
  getAllActivityList: ({ appSecret, include = 'cl' }) => ({
    url: 'v2/:clientId/activities/all-activities-list',
    method: 'get',
    params: { appSecret },
    isPublic: true,
  }),
  getJackpotList: ({ appSecret }) => ({
    url: 'v2/:clientId/activities/jackpot/list',
    method: 'get',
    params: { appSecret },
    isPublic: true,
  }),
  getProgressSummary: ({ appSecret }) => ({
    url: 'v2/:clientId/activities/progress-summary',
    method: 'get',
    params: { appSecret },
  }),
  getProgressDetail: ({ appSecret, locale }) => ({
    url: 'v2/:clientId/activities/progress-details',
    method: 'get',
    params: { appSecret, locale },
  }),
  getActivityDetail: ({ activityNo, appSecret }) => {
    if (!activityNo) {
      throw new Error('activityNo parameter is required for getActivityDetail API')
    }
    return {
      url: 'v2/:clientId/activities',
      method: 'get',
      params: { activityNo, appSecret },
    }
  },
  getActivityRanking: ({ appSecret }) => ({
    url: 'v2/:clientId/activities/ranking/basic-ranking',
    method: 'get',
    params: { appSecret },
    isPublic: true,
  }),
  getAchievements: ({ limit, page, appSecret }) => ({
    url: 'v2/:clientId/activities/achievements',
    method: 'get',
    params: {
      limit,
      page,
      appSecret,
    },
  }),
  getAchievementsProgress: ({ achievementNo, appSecret }) => ({
    url: 'v2/:clientId/activities/achievements/progress',
    method: 'get',
    params: { achievementNo, appSecret },
  }),
  getAchievementsIssued: () => ({ url: 'v2/:clientId/activities/achievements/issue', method: 'get' }),
  postPromoCode: (promoCode) => ({
    url: 'v2/:clientId/activities/promo',
    method: 'post',
    params: { promoCode },
  }),
  // 不收 receiveNo：帶 receiveNo 的領獎只能經 useRewardClaim 送出（spec 2026-10-19 REQ-9）
  sentAward: ({ activityNo, attended, gender, email, score, suggest, uidSite, affiliateCode, appSecret }) => ({
    url: 'v2/:clientId/activities/sent-award',
    method: 'post',
    params: { activityNo, attended, gender, email, score, suggest, uidSite, affiliateCode, appSecret },
  }),
  getReward: ({ activityNo, receiveNo, appSecret, attended }) => ({
    url: 'v2/:clientId/activities/rewards',
    method: 'post',
    params: { activityNo, receiveNo, appSecret, attended },
  }),
  getTotalReward: ({ rewardType }) => ({
    url: 'v2/:clientId/activities/reward-amount',
    method: 'get',
    params: { rewardType },
  }),
  getRewardList: ({ rewardType, count, appSecret, orderColumn, lang }) => ({
    url: 'v2/:clientId/activities/rewards',
    method: 'get',
    params: { rewardType, count, appSecret, orderColumn, lang },
  }),
  getCashRainReward: ({ activityNo, appSecret }) => ({
    url: `v2/:clientId/activities/cash-rain/exchange`,
    method: 'post',
    params: { activityNo, appSecret },
  }),
  getMaxExchangeAmount: (data) => ({ url: 'v2/:clientId/activities/diamond/exchange/max-amount', method: 'post', params: data }),
  settleAmount: (data) => ({ url: 'v2/:clientId/activities/diamond/exchange/settle', method: 'post', params: data }),
  exchange: (data) => ({ url: 'v2/:clientId/activities/exchange', method: 'post', params: data }),
  collect: (data) => ({ url: 'v2/:clientId/activities/collect', method: 'post', params: data }),
  getVipTable: ({ appSecret }) => ({ url: 'v2/:clientId/activities/viptable', method: 'get', params: { appSecret } }),
  getRankingList: () => ({ url: 'v2/:clientId/activities/ranking/promotion-ranking', method: 'get' }),
  getPublicRankingList: ({ appSecret }) => ({
    url: 'v2/:clientId/activities/ranking/public/promotion-ranking',
    method: 'get',
    params: { appSecret },
    isPublic: true,
  }),
  exchangeDiamond: ({ activityNo, exchangeAward = [] }) => ({
    url: 'v2/:clientId/activities/exchange/diamond',
    method: 'post',
    params: {
      activityNo,
      exchangeAward,
    },
  }),
  getHonorBroadcast: ({ isPwa = false, appSecret }) => ({
    url: 'v2/:clientId/activities/honor-broadcast',
    method: 'get',
    params: { isPwa, appSecret },
    isPublic: true,
  }),
  getInstantRebateCollectTime: () => ({ url: 'v2/:clientId/activities/rebate/rebate-collect-time', method: 'get' }),
  instantRebateEstimate: () => ({ url: 'v2/:clientId/activities/rebate/estimate', method: 'get' }),
  instantRebateCollect: () => ({ url: 'v2/:clientId/activities/rebate/collect', method: 'get' }),
  instantRebateHistory: ({ startDate, endDate, appSecret }) => ({
    url: 'v2/:clientId/activities/rebate/history',
    method: 'post',
    params: { startDate, endDate, appSecret },
  }),
  loseRebateHistory: ({ startDate, endDate, appSecret }) => ({
    url: 'v2/:clientId/activities/rebate/lose-rebate/history',
    method: 'post',
    params: { startDate, endDate, appSecret },
  }),
  getLevelBonusInfo: ({ appSecret }) => ({
    url: 'v2/:clientId/activities/level-bonus/info',
    method: 'get',
    params: { appSecret },
  }),
  getMissionHistory: ({ activityNo, appSecret }) => ({
    url: 'v2/:clientId/activities/mission-history',
    method: 'get',
    params: { activityNo, appSecret },
  }),
}
